export const QUERY_KEYS = {
  programs: "programs",
  program: "program",
  programVersions: "program-versions",
  events: "events",
  isEvaluated: "is-evaluated",
  adminNotifications: "admin-notifications",
  eventVersions: "event-versions",
  logs: "logs",
  users: "users",
  user: "user",
  programStatus: "program-status",
  healthCareEmployees: "healthCare-employees",
  classifiers: "classifiers",
  publicClassifiers: "public-classifiers",
  classifierValues: "classifier-values",
  professionalQualificationClassifiers: "professional-qualification-classifiers",
  healthCareAdresses: "healthCare-adresses",
  availableProfessionalActivityAddresses: "available-professional-activity-addresses",
  professionalActivityFilterAddresses: "professional-activity-filter-addresses",
  publicClassifierValues: "public-classifier-values",
  systemParameters: "system-parameters",
  systemParameterConfigurations: "system-parameter-configurations",
  notificationsTemplates: "notificationsTemplates",
  notificationRestTemplate: "notificationResetTemplate",
  healthcareInstitutions: "healthcare-institutions",
  accessibleHealthCareInstitutions: "accessible-healthcare-institutions",
  organizerInstitutions: "organizer-institutions",
  institutionRegistration: "institution-registration",
  institutionsRegistrations: "institutions-registrations",
  publicOrganizerInstitutionsForEvents: "public-organizer-institutions-for-events",
  adminOrganizerInstitutionsForEvents: "admin-organizer-institutions-for-events",
  publicOrganizerInstitutionsForPrograms: "public-organizer-institutions-for-programs",
  institutionEmployees: "institution-employees",
  notifications: "notifications",
  logsParameters: "logs-parameters",
  entrustableProfessionalActivities: "entrustable-professional-activities",
  certificatesOthetAndWithoutDocuments: "certificates-other-and-without-documents",
  certificatesBasedOnProgram: "certificates-based-on-program",
  certificateWithoutDocument: "certificate-without-document",
  certificateBasedOnProgram: "certificate-based-on-program",
  certificateOther: "certificate-other",
  certificate: "certificate",
  certificateDashboard: "certificate-dashboard",
  residencyStudyPrograms: "residency-study-programs",
  surveys: "surveys",
  respondentSurveys: "respondent-surveys",
  surveyAnswers: "survey-answers",
  licenses: "licenses",
  calculate: "calculate",
  specialist: "specialist",
  specialistSearch: "specialists-search",
  specialisstSearchForSpecialist: "specialist-search-for-specialist",
  specialistCertificiates: "specialist-certificates",
  contacts: "contacts",
  specialistContacts: "specialist-contacts",
  organizerInstitutionContacts: "organizer-institution-contacts",
  institutionName: "institution-name",
  specialistWorkPlaces: "specialist-work-places",
  specialistWorkPlace: "specialist-work-place",
  professionalActivities: "professional-activities",
  professionalActivitiesDetailed: "professional-activities-detailed",
  professionalActivityDepartments: "professional-activity-departments",
  mentors: "mentors",
  mentees: "mentees",
  mentee: "mentee",
  mentor: "mentor",
  developmentPlans: "development-plans",
  mentorQuestionnaires: "mentor-questionnaires",
  menteeDevelopmentPlans: "mentee-development-plans",
  staticContentList: "static-content-list",
  staticContentGet: "static-content-get",
  addresses: "addresses",
  competencies: "competencies",
  diplomas: "diplomas",
  generatedDocuments: "generated-documents",
  generatePdf: "generate-pdf",
  downloadFile: "download-file",
  questionnaires: "questionnaires",
  questionnairesStatistics: "questionnaires-statistics",
  externalEvaluationFormStatus: "externalEvaluationFormStatus",
  menteeUserDevelopmentPlanQuestionnaires: "mentee-users-development-plan-questionnaires",
  menteeUserDevelopmentPlanQuestionnaireAnswers: "mentee-user-development-plan-questionnaire-answers",
  newsList: "news-list",
  newsArticleGet: "news-article-get",
  informationalContentList: "informational-content-list",
  informationalContentArticleGet: "informational-content-article-get",
  informationalContentPageGet: "informational-content-page-get",
  programDrafts: "program-drafts",
  programStatuses: "program-statuses",
  integrations: "integrations",
  imports: "imports",
  latestEventSpecialistUsersImport: "imports",
  importRows: "import-rows",
  latestProfessionalActivityImport: "latest-professional-activity-import",
  downloadProfessionalActivities: "download-professional-activities",
  downloadInstitutionCertificates: "download-institution-certificates",
  evaluatorGroups: "evaluator-groups",
  certificateImport: "certificate-import",
  import: "import",
  programComments: 'program-comments',
  integrationSyncStats: 'integration-sync-stats',
  specialistUserLicenseComments: 'specialist-user-license-comments',
};
